<iframe #iframe frameborder="0" scrolling="no" (load)="resizeIframe(iframe)" [ngStyle]="style"></iframe>